const env = import.meta.env;

const conf = {
	appEnv: env.VITE_ENV,
	apiRoot: env.VITE_API_GW_URL
};

export const Config = {
	get: (prop: keyof typeof conf) => conf[prop]!,
	getEnvironment: (): string => Config.get('appEnv'),
	isProd: () => Config.getEnvironment() === 'production',
	isDev: () => !Config.isProd()
};
